<template>
  <v-container fluid>
    <v-snackbar id="snackbar" v-model="snackbar" :color="color" top :timeout="5000">
      <v-row>
        {{ text }}
        <v-spacer></v-spacer>
        <v-btn dark icon @click="snackbar = false">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-row>
    </v-snackbar>
    <v-row>
      <v-col cols="12" md="6" class="pt-15">
        <v-card v-if="details">
          <v-card-title>Booking Information</v-card-title>
          <v-card-subtitle>Booling details for reference: <strong>{{ $route.query.reference }}</strong></v-card-subtitle>
          <v-divider />
          <v-card-text>
            <div class="d-flex justify-space-between mb-3">
              <h3>Name</h3>
              <h3>{{ details.holderName }}</h3>
            </div>
            <div class="d-flex justify-space-between mb-3">
              <h3>Phone</h3>
              <h3>{{ details.phoneNumber }}</h3>
            </div>
            <div class="d-flex justify-space-between mb-3">
              <h3>Address</h3>
              <h3>{{ details.address }}</h3>
            </div>
            <v-divider />
            <div class="d-flex justify-space-between my-3">
              <h3>Card number</h3>
              <h3>{{ details.cardNumber }}</h3>
            </div>
            <div class="d-flex justify-space-between mb-3">
              <h3>Amount</h3>
              <h3>{{ details.amount | currency }}</h3>
            </div>

            <v-btn text color="primary" class="px-0" @click="termsDialog = !termsDialog">
              Terms & Conditions
              <v-icon right>
                mdi-chevron-right
              </v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-form ref="cardForm" v-model="valid" class="mt-15 mb-5">
          <v-card class="mx-auto">
            <v-card-title>
              Online Signature
            </v-card-title>
            <v-card-subtitle v-if="details">
              Dear {{ details.holderName }} You can sign online here
            </v-card-subtitle>
            <v-card-text>
              <v-file-input
                :rules="[
                  value => !value || value.size <= 2000000 || 'Image size should be less than 2 MB!',
                ]"
                accept="image/*"
                placeholder="Pick an image"
                prepend-inner-icon="mdi-id-card"
                label="Government ID"
                outlined
                @change="convertToBase64($event, 'gov')"
              />

              <div class="my-3">
                <label for="sign">Please sign here</label>
                <div style="border: 2px solid #e5e5e5;">
                  <VueSignaturePad ref="signaturePad" height="150px" />
                </div>
              </div>

              <img v-if="images.signature" :src="images.signature" width="80%">

              <div v-if="!loading" class="text-center">
                <v-btn v-if="images.signature" tile dark color="error" @click="clear">
                  clear Signature
                </v-btn>
                <v-btn tile dark color="indigo" @click="save">
                  Save Signature
                </v-btn>
              </div>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-btn
                large
                tile
                dark
                color="success"
                class="d-block mx-auto px-15"
                :loading="loading"
                @click="submitForm"
              >
                submit
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
    <v-dialog v-if="details" v-model="termsDialog" max-width="750">
      <v-card max-width="750">
        <v-card-title>Terms and Conditions</v-card-title>
        <v-card-text>
          <div v-html="details.termsAndConditions"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { getBookingDetails, storeSignature } from '@/links'

export default {
  data () {
    return {
      valid: true,
      snackbar: false,
      color: '',
      text: '',
      images: {
        govID: null,
        // cardFront: null,
        // cardBack: null,
        signature: null
      },
      termsDialog: false,
      loading: false,
      details: null
    }
  },
  head: {
    title: 'Verify bank card'
  },
  mounted () {
    this.$http.get(getBookingDetails(this.$route.query.reference)).then((response) => {
      console.log(response.data.data)
      if (response.status === 200) {
        this.details = response.data.data
      } else {
        this.snackbar = true
        this.color = 'error'
        this.text = 'Could not get booking details!'
        // this.$store.dispatch('activateAlert', { type: 'error', text: 'Could not get booking details!' })
      }
    }).catch((err) => {
      console.log(err)
    }).finally(() => {
      this.loading = false
    })
  },
  methods: {
    convertToBase64 (file, type) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (event) => {
        switch (type) {
          case 'gov':
            this.images.govID = event.target.result
            break
          // case 'cf':
          //   this.images.cardFront = event.target.result
          //   break
          // case 'cb':
          //   this.images.cardBack = event.target.result
          //   break
        }
      }
    },
    save () {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      if (!isEmpty) {
        this.images.signature = data
        this.$refs.signaturePad.lockSignaturePad()
        this.snackbar = true
        this.color = 'success'
        this.text = 'your signature has been saved successfully'
      } else {
        this.snackbar = true
        this.color = 'error'
        this.text = 'please write your signature first'
      }
    },
    clear () {
      this.images.signature = null
      this.$refs.signaturePad.undoSignature()
      this.$refs.signaturePad.openSignaturePad()
    },
    submitForm () {
      if (this.images.govID && this.images.signature) {
        this.loading = true
        const payload = {}
        setTimeout(() => {
          payload.customerSignature = this.images.signature
          payload.customerAttachments = [this.images.govID]
          this.$http.post(storeSignature(this.$route.query.reference), payload).then((response) => {
            if (response.status) {
              this.$router.push('/flights/verification/confirmed')
            } else {
              this.snackbar = true
              this.color = 'error'
              this.text = 'Could not store signature data!'
              // this.$store.dispatch('activateAlert', { type: 'error', text: 'Could not store signature data!' })
            }
          }).catch((err) => {
            console.log('error here', err)
          }).finally(() => {
            this.loading = false
          })
        }, 3000)
      } else {
        this.snackbar = true
        this.color = 'error'
        this.text = 'Please Upload all needed images and signature!'
        // this.$store.dispatch('activateAlert', { type: 'error', text: 'Please Upload all needed images and signature!' })
      }
    }
  }
}
</script>
